import React from 'react';
import { Card, Statistic, Progress, Row, Col } from 'antd';

interface StatItem {
  title: string;
  value: number | string;
  precision?: number;
  suffix?: string;
  prefix?: string;
}

interface ProgressItem {
  title: string;
  percent: number;
  status?: 'success' | 'exception' | 'normal' | 'active';
}

interface CoachStatsCardProps {
  title: string;
  stats?: StatItem[];
  progress?: ProgressItem[];
  loading?: boolean;
}

const CoachStatsCard: React.FC<CoachStatsCardProps> = ({
  title,
  stats = [],
  progress = [],
  loading = false
}) => {
  return (
    <Card title={title} loading={loading}>
      {stats.length > 0 && (
        <Row gutter={16} style={{ marginBottom: 16 }}>
          {stats.map((stat, index) => (
            <Col span={12} key={index}>
              <Statistic
                title={stat.title}
                value={stat.value}
                precision={stat.precision}
                suffix={stat.suffix}
                prefix={stat.prefix}
              />
            </Col>
          ))}
        </Row>
      )}
      
      {progress.length > 0 && (
        <div>
          {progress.map((item, index) => (
            <div key={index} style={{ marginBottom: 16 }}>
              <div style={{ marginBottom: 8 }}>
                {item.title}
              </div>
              <Progress percent={item.percent} status={item.status} />
            </div>
          ))}
        </div>
      )}
    </Card>
  );
};

export default CoachStatsCard; 